module.exports = __webpack_public_path__ + "static/media/avatar_33.9ee78317.svg";